import styled from 'styled-components';
import { NEUTRAL_300 } from '../../styles/colors';
import { BODY_NORMAL_BOLD } from '../../styles/typography';

export const Description = styled.span`
  color: ${NEUTRAL_300};
  ${BODY_NORMAL_BOLD};
  padding-top: 16px;
`;
